<div class="dialog-header">
  <h2>{{ title }}</h2>
  <button mat-icon-button (click)="cancel()" aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div *ngIf="loading" class="loading">
  <mat-spinner [diameter]="32"></mat-spinner>
  <span>{{ 'MENU.MIGRATE_RELATED_PRODUCTS_LOADING' | translate }}</span>
</div>

<div *ngIf="errorMessage" class="error">
  {{ errorMessage }}
</div>

<div *ngIf="!loading && rows.length === 0 && !errorMessage" class="empty">
  {{ 'MENU.MIGRATE_RELATED_PRODUCTS_EMPTY' | translate }}
</div>

<div *ngIf="!loading && rows.length > 0" class="bulk-actions">
  <button mat-stroked-button (click)="applyAllWhereTargetEmpty()">{{ 'MENU.MIGRATE_RELATED_PRODUCTS_APPLY_EMPTY' | translate }}</button>
  <button mat-stroked-button (click)="skipAllConflicts()">{{ 'MENU.MIGRATE_RELATED_PRODUCTS_SKIP_CONFLICTS' | translate }}</button>
  <button mat-stroked-button (click)="selectAllOverwrite()">{{ 'MENU.MIGRATE_RELATED_PRODUCTS_SELECT_ALL_OVERWRITE' | translate }}</button>
  <button mat-stroked-button (click)="selectAllSkip()">{{ 'MENU.MIGRATE_RELATED_PRODUCTS_SELECT_ALL_SKIP' | translate }}</button>
</div>

<div *ngIf="!loading && rows.length > 0" class="rows">
  <div *ngFor="let row of rows; trackBy: trackByProductId" class="row"
       [class.row--conflict]="row.item.hasConflict">
    <div class="row__product">
      <div class="row__product-name">{{ row.item.productName || row.item.productId }}</div>
      <div class="row__product-id">{{ row.item.productId }}</div>
    </div>

    <div class="row__columns">
      <div class="row__column">
        <div class="row__column-title">{{ 'MENU.MIGRATE_RELATED_PRODUCTS_SOURCE' | translate }}</div>
        <div *ngFor="let entry of row.item.source" class="entry">
          <div *ngIf="entry.name" class="entry__name">{{ entry.name }}</div>
          <ul class="entry__products">
            <li *ngFor="let p of entry.products">{{ p.name || p.id }}</li>
          </ul>
        </div>
      </div>

      <div class="row__column">
        <div class="row__column-title">{{ 'MENU.MIGRATE_RELATED_PRODUCTS_TARGET' | translate }}</div>
        <div *ngIf="row.item.target.length === 0" class="empty-target">{{ 'MENU.MIGRATE_RELATED_PRODUCTS_TARGET_EMPTY' | translate }}</div>
        <div *ngFor="let entry of row.item.target" class="entry">
          <div *ngIf="entry.name" class="entry__name">{{ entry.name }}</div>
          <ul class="entry__products">
            <li *ngFor="let p of entry.products">{{ p.name || p.id }}</li>
          </ul>
        </div>
      </div>

      <div class="row__column row__action">
        <mat-radio-group [(ngModel)]="row.action" name="action-{{row.item.productId}}">
          <mat-radio-button [value]="Action.Skip">{{ 'MENU.MIGRATE_RELATED_PRODUCTS_ACTION_SKIP' | translate }}</mat-radio-button>
          <mat-radio-button [value]="Action.Overwrite">{{ 'MENU.MIGRATE_RELATED_PRODUCTS_ACTION_OVERWRITE' | translate }}</mat-radio-button>
          <mat-radio-button [value]="Action.Append">{{ 'MENU.MIGRATE_RELATED_PRODUCTS_ACTION_APPEND' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </div>
</div>

<div class="dialog-footer">
  <button mat-button (click)="cancel()" [disabled]="applying">{{ 'COMMON.CANCEL' | translate }}</button>
  <button mat-raised-button color="primary" (click)="apply()"
          [disabled]="applying || loading || rows.length === 0">
    <mat-spinner *ngIf="applying" [diameter]="16" style="display: inline-block; margin-right: 6px;"></mat-spinner>
    {{ 'COMMON.APPLY' | translate }}
  </button>
</div>
